import * as FileSystem from 'expo-file-system';
import { Platform } from 'react-native';
import Constants from 'expo-constants';
import * as Application from 'expo-application';
import { shareAsync } from 'expo-sharing';

/**
 * Write file content to local storage and read the uri to file
 * @async
 * @param {object} - object containing fileContent and fileName
 * @return {string} uri - string to the file
 */
export async function saveToFile({ fileContent, fileName }) {
  try {
    const fileDirectory = `${FileSystem.documentDirectory}${fileName}`;
    await FileSystem.writeAsStringAsync(
      fileDirectory,
      fileContent,
      { encoding: FileSystem.EncodingType.Base64 },
    );
    const { uri } = await FileSystem.getInfoAsync(fileDirectory);
    return uri;
  } catch (error) {
    return error;
  }
}

/**
 * Extract file uri from url and , when fileContent is not given
 * @async
 * @param {object} - object containing fileName and url
 * @return {string} uri - string to the file
 */
export async function saveUrlToFile({ fileName, url }) {
  try {
    const fileNameUri = `${await FileSystem.documentDirectory}${fileName}`;
    const { uri } = await FileSystem.downloadAsync(url, fileNameUri);
    shareAsync(uri);
    return uri;
  } catch (error) {
    return error;
  }
}

/**
 * Get formatted string to display version of our app based on values in the current app manifest
 * and based on the Platform.
 * @example
 * Platform: iOS/Android
 *   Output Format: 'Version <version> (<build>)'
 *   Output Example: 'Version 3.0.37 (56)'
 * Platform: web
 *   Output Format: 'Version <version>'
 *   Output Example: 'Version 3.0.37'
 */
export const getFormattedAppVersion = () => {
  const buildNumber = Platform.select({
    android: ` (${Application.nativeBuildVersion})`,
    default: '',
    ios: ` (${Application.nativeBuildVersion})`,
  });

  return `Version ${Constants.expoConfig.version}${buildNumber}`;
};

/**
 * Get the base url including version pathname dependending on the build type
 * @returns {string} base gateway server url
 */
export const getBaseApplicationServerUrl = () => {
  if (Platform.OS === 'web') {
    return `${window.location.origin}/api/v1`;
  }
  return Constants.expoConfig.extra.SERVER_URL;
};

/**
 * Promise-based alternative to delaying via setTimeout. Resolves after provided time in ms has
 * passed.
 * @param {number} ms milliseconds to delay
 */
export const delay = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
